import { rbacCapabilityCheckAllOf } from '@libs/rbac/functions'
import { readUIAttackPath } from '@libs/rbac/permissions'

export const canAccessToAttackPath = rbacCapabilityCheckAllOf(
  readUIAttackPath()
)

export const canAccessToAttackPathTier0 = rbacCapabilityCheckAllOf(
  readUIAttackPath()
)
